import { useState } from 'react';
import { Box } from '@interstate/components/Box';
import { Grid } from '@interstate/components/Grid';
import { IconButton } from '@interstate/components/IconButton';
import { Typography } from '@interstate/components/Typography';
import { EyeIcon, EyeSlashIcon } from '@interstate/components/Icons';
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';

type AcvLineItemProps = {
    acv: number;
    originalIndex: number;
};

const AcvLineItem = ({ acv, originalIndex }: AcvLineItemProps) => {
    const [showAcv, setShowAcv] = useState(false);
    const toggleAcv = () => setShowAcv((prev) => !prev);
    const formattedAcv = formatDollarsAndCents(acv);
    const obfuscatedAcv = formattedAcv.replace(/./g, '•');

    return (
        <Grid
            container
            sx={{ justifyContent: 'space-between', width: '100%', alignItems: 'center', pr: 0 }}
            data-testid={`trade-acv-detail-${originalIndex}`}
        >
            <Typography tag="span" variant="label-sm" color="sem.color.on-surface.muted" sx={{ flex: '1 1 0', minWidth: 0 }}>
                ACV
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <IconButton
                    size="sm"
                    buttonStyle="tertiary"
                    onClick={toggleAcv}
                    data-testid={`trade-acv-toggle-detail-${originalIndex}`}
                >
                    {showAcv ? <EyeSlashIcon /> : <EyeIcon />}
                </IconButton>
                <Typography tag="span" variant="body-xs" color="sem.color.on-surface.default">
                    {showAcv ? formattedAcv : obfuscatedAcv}
                </Typography>
            </Box>
        </Grid>
    );
};

export default AcvLineItem;
